// extracted by mini-css-extract-plugin
export default {"faqs":"faqs_faqs__9LuwI","faq-blocks":"faqs_faq-blocks__Ip+y7","faq-question":"faqs_faq-question__G8R+a","faq-answers":"faqs_faq-answers__TOB4X"};